export default __webpack_public_path__ + "static/media/twitter.87b0e0e5.svg";